import * as React from 'react';
import parse from 'html-react-parser';

import { useAuth } from "../../../../auth/useAuth";

import ApiKeyContext from "../../../../contexts/ApiKeyContext.js";
import SaleReportComment from "./SaleReportComment.js";

import './SaleReportConversationBody.scss';

export default function SaleReportConversationBody({ saleReportId, ts, lastUpdate }) {
	const API_KEY_CONTEXT = React.useContext(ApiKeyContext);
	const { currentUser } = useAuth();

	const [pollingIntervalTime, setPollingIntervalTime] = React.useState(20 * 1000);
	const [comments, setComments] = React.useState([]);
	const [pollingInterval, setPollingInterval] = React.useState(false);

	const getSaleReportComments = React.useCallback(async (backgroundLoad = false, id = false) => {
		!backgroundLoad && document.body.classList.add("is-loading");

		const paths = {
			id: true,
			message: true,
			created_on: true,
			created_by_profile: ['id', 'given_name', 'family_name', 'email'],
		};
		const searchOptions = {
			paths: paths,
			sort: "{created_on} DESC",
			limit: 50,
			filter: [{
				property: "{sale_report}",
				operator: "=",
				value: id,
			}],
		};

		const response = await SaleReportComment.SearchBy(searchOptions);
		setComments(response);

		!backgroundLoad && document.body.classList.remove("is-loading");

		const last_message = response.length && response[0];
		if (!last_message) {
			return;
		}

		// Short to long polling
		const secs = (Date.now() - Date.parse(last_message?.created_on + "Z")) / 1000;

		if (secs > 60 * 10) {
			setPollingIntervalTime(60 * 1);
		} else if (secs > 60 * 2) {
			setPollingIntervalTime(20);
		} else if (secs > 60) {
			setPollingIntervalTime(10);
		} else {
			setPollingIntervalTime(5);
		}
	}, [saleReportId]);
	React.useEffect(() => {
		getSaleReportComments(false, saleReportId);
	}, [ts, saleReportId, lastUpdate]);
	React.useEffect(() => {
		pollingInterval && clearInterval(pollingInterval);

		const interval = setInterval(
			() => getSaleReportComments(true, saleReportId),
			1000 * pollingIntervalTime
		);
		setPollingInterval(interval);
		return () => clearInterval(pollingInterval);
	}, [saleReportId, pollingIntervalTime, getSaleReportComments]);


	return (
		<div className="sale-report-conversation-body">
			{
				comments.map(comment => {
					const localDate = new Date(comment.created_on + 'Z').toLocaleString("en-US", {
						localeMatcher: "best fit",
						timeZoneName: "short",

						// dateStyle: 'short',
						year: 'numeric',
						month: 'short',
						day: 'numeric',

						hour: '2-digit',
						minute: '2-digit'
					}).replace(' AM', 'am').replace(' PM', 'pm');
					const isMe = currentUser.email.toLowerCase() == comment.created_by_profile?.email?.toLowerCase();

					return (
						<div className={"sale-report-comment " + (isMe && 'is-me')} key={comment.id}>
							<div className="sale-report-comment-header">
								<div className="sale-report-comment-author">
									{comment.created_by_profile?.given_name}
									&nbsp;
									{comment.created_by_profile?.family_name}
								</div>
								<div className="sale-report-comment-date">
									{localDate}
								</div>
							</div>
							<div className="sale-report-comment-message">
								{parse(comment.message)}
							</div>
						</div>
					);
				})
			}
		</div>
	);
}